module.exports = __webpack_public_path__ + "img/s11-min.e7d0ccfa.png";